module.exports = __webpack_public_path__ + "img/avatar.4ebd8bc3.jpg";